import { render, staticRenderFns } from "./ButtonFlat.vue?vue&type=template&id=5361017a&"
import script from "./ButtonFlat.vue?vue&type=script&lang=js&"
export * from "./ButtonFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports